export class Folder{
	constructor(
			public id: number,
			public name: string,
			public createdAt,
			public updatedAt,
			public user_id: any,
			public permissions: string,
			public hasparent: number,
			public haschild: number,
			public activo: number,
			public companyId: number
		){

	}
}